import { render } from "./size-guide-content.vue?vue&type=template&id=7ff4abf3"
import script from "./size-guide-content.vue?vue&type=script&lang=js"
export * from "./size-guide-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__